import { ButtonList } from '../button-list';

export class AppButton extends ButtonList {
  name = 'apps';
}
